import React, { useEffect, useState } from "react";
import AddLomPresidentModal from "../Modals/LomPresident/AddLomPresident";
import EditLomPresidentModal from "../Modals/LomPresident/EditLomPresident";
import Swal from "sweetalert2";
import axios from "axios";
import { MdDeleteForever } from "react-icons/md";
import {
  FaFacebook,
  FaInstagram,
  FaYoutube,
  FaLinkedin,
  FaPen,
} from "react-icons/fa";

const LomPresidentPage = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [presidents, setPresidents] = useState([]);
  const [userRole, setUserRole] = useState("");

  const toggleModal = () => setIsModalOpen(!isModalOpen);
  const toggleEditModal = () => setIsEditModalOpen(!isEditModalOpen);

  const fetchLomPresidents = async () => {
    try {
      const response = await axios.get("/lom_president/get_lom_president");
      setPresidents(response.data);
    } catch (error) {
      console.error("Error fetching LOM Presidents:", error);
    }
  };

  const handleAddPresident = async (data) => {
    try {
      const response = await axios.post("/api/add_lom_president", data);
      fetchLomPresidents();
      toggleModal();
      Swal.fire("Success!", "LOM President added successfully!", "success");
    } catch (error) {
      Swal.fire(
        "Error!",
        error.response.data.error || "Something went wrong",
        "error"
      );
    }
  };

  const handleEditPresident = async (data) => {
    try {
      await axios.put(`/api/edit_lom_president/${data.id}`, data);
      setPresidents(
        presidents.map((president) =>
          president.id === data.id ? { ...president, ...data } : president
        )
      );
      toggleEditModal();
      Swal.fire("Success!", "LOM President updated successfully!", "success");
    } catch (error) {
      Swal.fire(
        "Error!",
        error.response.data.error || "Something went wrong",
        "error"
      );
    }
  };

  const handleDeletePresident = async (lomPresidentId) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          // Send the lom_president_id to the backend for deletion
          await axios.delete(
            `/lom_president/delete_lom_president/${lomPresidentId}`
          );

          // Remove the deleted president from the state
          setPresidents(
            presidents.filter(
              (president) => president.lom_president_id !== lomPresidentId
            )
          );

          Swal.fire("Deleted!", "Your record has been deleted.", "success");
        } catch (error) {
          Swal.fire(
            "Error!",
            error.response?.data?.error || "Something went wrong",
            "error"
          );
        }
      }
    });
  };

  const openEditModal = (record) => {
    setSelectedRecord(record);
    // alert(record.lomName);
    toggleEditModal();
  };

  useEffect(() => {
    fetchLomPresidents();
    const profession_id = sessionStorage.getItem("profession_id");
    if (profession_id) {
      setUserRole(profession_id);
    }
  }, [sessionStorage.getItem("profession_id")]);

  //[presidents]

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-16 space-y-6 mb-10">
      <div className="w-full max-w-7xl mx-auto mt-14 bg-white dark:bg-[#1a202c] rounded-xl shadow-2xl p-6">
        <div className="mb-6">
          <div className="flex justify-between items-center mb-6">
            <h1 className="text-2xl font-bold text-gray-800">LO</h1>
            <button
              className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600"
              onClick={toggleModal}
            >
              Add LO
            </button>
          </div>

          <table className="min-w-full border-collapse">
            <thead>
              <tr>
                <th className="border px-4 py-2">LO</th>
                <th className="border px-4 py-2">Year</th>
                <th className="border px-4 py-2">Name</th>
                <th className="border px-4 py-2">Member ID</th>
                <th className="border px-4 py-2">Contact Number</th>
                <th className="border px-4 py-2">Whatsapp Number</th>
                <th className="border px-4 py-2">Social Media</th>
                <th className="border px-4 py-2">Actions</th>
              </tr>
            </thead>
            <tbody>
              {presidents.map((president) => (
                <tr key={president.id}>
                  <td className="border px-4 py-2">{president.lomName}</td>
                  <td className="border px-4 py-2">{president.year}</td>
                  <td className="border px-4 py-2">{president.name}</td>
                  <td className="border px-4 py-2">{president.membershipId}</td>
                  <td className="border px-4 py-2">
                    {president.contactNumber}
                  </td>
                  <td className="border px-4 py-2">
                    {president.whatsapp_number}
                  </td>
                  <td className="border px-4 py-2">
                    {/* Social Media Icons */}

                    {president.facebook ||
                    president.instagram ||
                    president.youtube ||
                    president.linkedin ? (
                      <div>
                        {" "}
                        <div className="flex space-x-2">
                          <a
                            href={president.facebook || "/login"}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {president.facebook ? (
                              <FaFacebook
                                className={`text-blue-500 ${
                                  !president.facebook &&
                                  "opacity-50 cursor-pointer"
                                }`}
                              />
                            ) : (
                              []
                            )}
                          </a>
                          <a
                            href={president.instagram || "/login"}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {president.instagram ? (
                              <FaInstagram
                                className={`text-red-800 ${
                                  !president.instagram &&
                                  "opacity-50 cursor-pointer"
                                }`}
                              />
                            ) : (
                              []
                            )}
                          </a>
                          <a
                            href={president.youtube || "/login"}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {" "}
                            {president.youtube ? (
                              <FaYoutube
                                className={`text-red-500 ${
                                  !president.youtube &&
                                  "opacity-50 cursor-pointer"
                                }`}
                              />
                            ) : (
                              []
                            )}
                          </a>
                          <a
                            href={president.linkedin || "/login"}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {president.linkedin ? (
                              <FaLinkedin
                                className={`text-blue-700 ${
                                  !president.linkedin &&
                                  "opacity-50 cursor-pointer"
                                }`}
                              />
                            ) : (
                              []
                            )}
                          </a>
                        </div>
                      </div>
                    ) : (
                      <div>-</div>
                    )}
                  </td>
                  <td className="border px-4 py-2">
                    {/* Actions Icons */}
                    <div className="flex space-x-2 justify-center">
                      <FaPen
                        className="text-amber-400 text-xl cursor-pointer"
                        onClick={() => openEditModal(president)}
                      />
                      {userRole !== "4" && (
                        <MdDeleteForever
                          className="text-red-500 text-2xl cursor-pointer"
                          onClick={() =>
                            handleDeletePresident(president.lom_president_id)
                          }
                        />
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <AddLomPresidentModal
        show={isModalOpen}
        onClose={toggleModal}
        onSubmit={handleAddPresident}
      />
      {isEditModalOpen && selectedRecord && (
        <EditLomPresidentModal
          show={isEditModalOpen}
          onClose={toggleEditModal}
          onSubmit={handleEditPresident}
          president={selectedRecord}
        />
      )}
    </div>
  );
};

export default LomPresidentPage;
